import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useShopifyPrice } from '../hooks/useShopifyPrice';

export function DropdownProductCard({ product, index, onClose }) {
  const navigate = useNavigate();
  const { price, loading } = useShopifyPrice(product.id);
  const displayPrice = loading ? product.price : (price || product.price);

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.07 }}
      className="cursor-pointer group px-8 py-7"
      onClick={() => { navigate(`/products/${product.id}`); onClose(); }}
    >
      <div
        className="flex items-center justify-center mb-5 overflow-hidden"
        style={{ height: '120px' }}
      >
        <motion.img
          src={product.image}
          alt={product.title}
          className="h-24 w-24 object-contain"
          whileHover={{ scale: 1.06 }}
          transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
        />
      </div>

      <p className="text-xs font-medium tracking-[0.2em] uppercase mb-1 transition-colors"
        style={{ color: '#B8704D' }}>
        {product.subtitle}
      </p>
      <h3 className="text-base font-medium mb-1 transition-colors"
        style={{ color: '#1A2A1A' }}
        onMouseEnter={e => e.currentTarget.style.color = '#B8704D'}
        onMouseLeave={e => e.currentTarget.style.color = '#1A2A1A'}>
        {product.title}
      </h3>
      <p className="text-xs" style={{ color: 'rgba(26,42,26,0.45)' }}>
        ${displayPrice.toFixed(2)} &nbsp;·&nbsp; {product.supplyDays} Day Supply
      </p>
    </motion.div>
  );
}
